import { Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";
import * as moment from 'moment';

@Pipe({
    name: "kcmsIncludeSecondsDateTwelve",
    pure: true
})

export class kcmsIncludeSecondsDateTwelvePipe extends DatePipe implements PipeTransform {
    offsetTimeZone: any;
    offsetMinutes: any;
    offsetTimeVal: any;
    transform(value: any): string | null {
        if (value) {
            if (value != null && value != '' && value != 'none' && value != 'None') {



                this.offsetTimeZone = (typeof localStorage.getItem('timezone') === 'undefined') ? null : localStorage.getItem('timezone');
                if (this.offsetTimeZone == null || this.offsetTimeZone === 'undefined' || Number.isNaN(this.offsetTimeZone)) {

                    this.offsetTimeZone = -5.00;
                    this.offsetMinutes = 0;

                    this.offsetTimeVal = (-5.00 * 3600000);

                }
                else {

                    this.offsetTimeZone = localStorage.getItem('timezone');
                    this.offsetMinutes = 30;

                    this.offsetTimeVal = (this.offsetTimeZone * 3600000);



                }

                var dateTimeZoneDiff = value.split(/[- :]/),
                    dateFinal = new Date(dateTimeZoneDiff[0], dateTimeZoneDiff[1] - 1, dateTimeZoneDiff[2], dateTimeZoneDiff[3], dateTimeZoneDiff[4], dateTimeZoneDiff[5]);
                dateFinal.setMilliseconds(Number(this.offsetTimeVal));




                var dateString = moment(dateFinal).format('MM/DD/YYYY hh:mm:ss');

                var dateObj = new Date(dateString);
                var momentObj = moment(dateObj);

                var momentString = momentObj.format('DD/MM/YYYY hh:mm:ss a'); // 2016-07


                return momentString;

            }
            else {
                return '';
            }

        }
    }
}




